import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" gap={1} mt={2}>
      <IconButton 
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 1}
        sx={{ 
          color: 'white',
          '&.Mui-disabled': {
            color: 'grey.500'
          }
        }}
      >
        <ChevronLeft />
      </IconButton>
      <Typography color="white">
        Page {currentPage} of {totalPages}
      </Typography>
      <IconButton 
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        sx={{ 
          color: 'white',
          '&.Mui-disabled': {
            color: 'grey.500'
          }
        }}
      >
        <ChevronRight />
      </IconButton>
    </Box>
  );
};

export default Pagination; 